import { Resource } from "../resource";


export class PriceRange extends Resource {
 minPrice: number
 maxPrice: number
 minGlobal: number
 maxGlobal: number   
}